"use strict";

module.exports = require("./is-implemented")() ? String.prototype.contains : require("./shim");



//////////////////
// WEBPACK FOOTER
// /Users/Fuunnx/workspace/zygmund/~/es5-ext/string/#/contains/index.js
// module id = ../../../node_modules/es5-ext/string/#/contains/index.js
// module chunks = 1